import shallow from "zustand/shallow";
import { useShelvingStore } from "../store";

export const allPrices = {totalPrice: 0}

export const usePrice = () => {
    const { priceFront, priceBack, priceLeft, priceRight, } = useShelvingStore(state => ({
        priceFront: state.shelving.front.price,
        priceBack: state.shelving.back.price,
        priceLeft: state.shelving.left.price,
        priceRight: state.shelving.right.price,
    }), shallow);
    return {
        totalPrice: priceFront.current + priceBack.current + priceLeft.current + priceRight.current,
        oldTotalPrice: priceFront.old + priceBack.old + priceLeft.old + priceRight.old,
    }
}
